import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Components */
import { Icon } from "../../components"

/* QR CODE */
import { QRCodeSVG } from "qrcode.react"

/* HTML to PNG */
import { toPng } from "html-to-image"

/* Download JS */
import download from "downloadjs"

/* HTML to PDF */
import { jsPDF } from "jspdf"

Modal.setAppElement("#root")


/* Widget QR Modal — the poster of the point. It is opened by the reference: this._qr.open(item) */
class QrModal extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            organization: null
        }
    }

    /* Open the poster of the point */
    open = organization => {
        this.setState({ visible: true, organization })
    }

    /* Close the poster */
    close = () => {
        this.setState({ visible: false, organization: null })
    }

    /* Download PNG */
    downloadPNG = () => {
        const qr = document.getElementById("qr-image")
        toPng(qr).then(url => download(url, "bookify.png"))
    }

    /* Download PDF */
    downloadPDF = () => {

        const qr = document.getElementById("qr-image")

        toPng(qr).then(url => {
            const image = new Image()
            image.src = url
            const pdf = new jsPDF()
            pdf.addImage(image, "PNG", 0, 0, 120, 120 * qr.offsetHeight / qr.offsetWidth)
            pdf.save("bookify.pdf")
        })
    }

    render = () => {

        /* Fields */
        const { visible, organization } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={this.close}
                className="organization-qr-modal"
                overlayClassName="organization-qr-overlay"
                closeTimeoutMS={200}
            >

                <div className="organization-qr-modal-header">
                    <h2>QR</h2>
                    <div onClick={this.close} className="organization-qr-modal-close">
                        <Icon name="close" size={11} width={2.2} />
                    </div>
                </div>

                {organization &&
                    <div className="organization-qr-modal-body">
                        <div className="qr-image">

                            <div className="qr-image-container" id="qr-image">
                                <div className="qr-image-inner">

                                    <div className="qr-image-scan-me">SCAN ME</div>

                                    <div className="qr-image-logo">
                                        <img src="/images/bookify.png" alt="Bookify" />
                                    </div>

                                    {organization.serviceMode === "TIME_BASED" && <div className="qr-image-title" style={{ fontSize: organization.name.length > 10 ? 30 : 40 }}>{organization.name}</div>}
                                    {organization.serviceMode === "TIME_BASED" && <div className="qr-image-text">Запишись онлайн — быстро и удобно!</div>}

                                    {organization.serviceMode === "QUEUE_BASED" && <div className="qr-image-title" style={{ fontSize: 30, padding: 0 }}>Встать в очередь</div>}
                                    {organization.serviceMode === "QUEUE_BASED" && <div className="qr-image-text" style={{ fontSize: 22 }}>{organization.name}</div>}

                                    <div className="qr-image-left-line" />
                                    <div className="qr-image-top-line" />
                                    <div className="qr-image-right-line" />
                                    <div className="qr-image-bottom-line" />

                                    <div className="qr-image-box">
                                        <div className="qr-image-box-text"></div>
                                        <QRCodeSVG value={`https://i.bookify.kz/g/${organization.uid}?source=qr`} level="Q" size={230} />
                                    </div>

                                    <div className="qr-image-link">При поддержке <span>bookify.kz</span></div>
                                </div>
                            </div>

                            <div className="qr-image-buttons">
                                <div onClick={() => this.downloadPNG()} className="qr-image-button">Скачать <span>.PNG</span></div>
                                <div onClick={() => this.downloadPDF()} className="qr-image-button red">Скачать <span>.PDF</span></div>
                            </div>
                        </div>

                    </div>
                }

            </Modal>
        )
    }
}

export default QrModal
